export default {
  SET_NOTIFICATIONS_COUNTER: 'SET_NOTIFICATIONS_COUNTER',
  CLOSE_DOCUMENT_NOTIFICATIONS_POPOVER: 'CLOSE_DOCUMENT_NOTIFICATIONS_POPOVER',
  CLOSE_DOSSIER_NOTIFICATIONS_POPOVER: 'CLOSE_DOSSIER_NOTIFICATIONS_POPOVER'
}
